import {observer} from 'mobx-react-lite'
import React from 'react'
import tw from 'tailwind-styled-components'
import {Lang} from 'yougile-lang'
import {Avatar} from '@components/common/base/avatar'
import {UserName} from '@components/common/base/user-name'
import {useChatStore} from '../chat-store'

const TwChatTyping = tw.div<{$visible: boolean}>`
  w-full
  px-16
  py-4
  flex
  items-center
  text-secondary
  text-12
  leading-4
  ${p => (p.$visible ? 'visible' : 'invisible')}
`

const TwUser = tw.span`
  min-w-0
  flex-initial
  flex
  gap-8
`

const TwRest = tw.span`
  flex-initial
  overflow-hidden
  text-ellipsis
  whitespace-nowrap
`

interface Props {
  className?: string
}

export const ChatTyping = observer(({className}: Props) => {
  const [state] = useChatStore()
  const users = state.whoIsTyping
  const firstUserId = users[0]
  const restCount = Math.max(users.length - 1, 0)

  return (
    <TwChatTyping $visible={!!users.length} className={className}>
      {firstUserId && (
        <TwUser>
          <Avatar
            userId={firstUserId}
            size={16}
            hideStatus
            hideHint
            hideOutline
            className="flex-none"
          />
          <UserName
            userId={firstUserId}
            context="override"
            className="flex-initial"
          />
        </TwUser>
      )}
      <TwRest>
        &nbsp;{restCount > 0 ? Lang.msg.moreTyping(restCount) : Lang.msg.typing}
      </TwRest>
    </TwChatTyping>
  )
})
